import { render, staticRenderFns } from "./HeaderControlsAuditLog.vue?vue&type=template&id=153f505d&"
import script from "./HeaderControlsAuditLog.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports